import {currentPage, initNewSection} from '../common/layout';
import { banners } from '../common/utils/fn';
import { getLoadMoreContent } from '../common/utils/load-more-btn-new.-loader';

currentPage.pageInit = ($page, pageData, pageId) => {
    
    let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
    loadMoreButton?.addEventListener('click', (event) => {
      event.preventDefault();
      getLoadMoreContent().then((api) => {
        api.loadMoreButtonNew(loadMoreButton);
      });
    });
}

currentPage.pageLoadMore = ($html, $btnBox) => {
    //$btnBox.replaceWith($html);
    initNewSection($html);
    
    let loadMoreButton = document.querySelector('.m1-pager--next .m1-button');
    loadMoreButton?.addEventListener('click', (event) => {
      event.preventDefault();
      getLoadMoreContent().then((api) => {
        api.loadMoreButtonNew(loadMoreButton);
      });
    });

    banners($html);
}